import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class EnvService {
	private envConfig = (window as any).env || {};

	get(key: string): any {
		return this.envConfig[key];
	}
}
